// Generated from products/analytics/shared/custom/aliveByMistake/eventIds.ts; run analytics generate:site-runtime.
// Stable Alive by Mistake wire allocation. Never renumber or reuse these codes.
export enum aliveByMistakeEventId {
  action = "an.07",
  summary = "an.08",
}
